/** 站点公开地址：用于 canonical / og / sitemap。部署后改成真实域名，或设置 VITE_SITE_URL 覆盖。 */
export const SITE_URL = (import.meta.env.VITE_SITE_URL as string | undefined) || 'https://pagedrop.fologde.com'

/** 一方工具箱主站地址 */
export const MAIN_SITE = 'https://tool.fologde.com'

export function siteUrl(path: string): string {
  return `${SITE_URL.replace(/\/+$/, '')}${path}`
}
